module.exports = __webpack_public_path__ + "static/media/dreamerhug-3.06f4ae1f.jpg";